import {
  EntityDropdownInput,
  EntityDropdownProps,
} from "#batteries-included-components/Dropdowns/EntityDropdownInput";
import { DeviceAdapter, DeviceTypeType } from "@validereinc/domain";
import React from "react";

export const DeviceTypeDropdownInput = ({
  name = "type",
  label,
  ...props
}: Omit<EntityDropdownProps<DeviceTypeType>, "fetchEntityList">) => {
  return (
    <EntityDropdownInput
      fetchEntityList={DeviceAdapter.types.getList}
      label={label ?? "Type"}
      name={name}
      sort={{
        sortBy: "name",
        sortDirection: "asc",
      }}
      {...props}
    />
  );
};
